import React from 'react';
import cx from 'classnames';
import * as Meta from '@elevio/kb-kit/lib/components/meta';
export function Logo({ className }) {
  return (
    <Meta.HomeLink
      className={cx('nav-logo', className)}
      title="go to home page"
    >
        <img src="https://go.cynet.com/hubfs/Cynet%20Docs%20Files/logo_white_98x24_1.png" alt="Cynet logo" className="logo-img" height="24" />
    </Meta.HomeLink>
  );
}
